import { Module } from 'vuex';
import { RootState } from '@/store/store';
import { IEditorState } from '@/editor/store/editor.store.types';
import { editorContent } from '@/editor/editor-block/store/editor-content.store';
import { editorUi } from '@/editor/editor-block/store/editor-ui.store';

export const editor: Module<IEditorState, RootState> = {
  modules: {
    editorUi,
    editorContent,
  },
  namespaced: true,
};
